export const blockIconsNavigationApps = (
	<span className='material-symbols-outlined'>apps</span>
);
